import React, {useState} from 'react';
import moment from 'moment';
import {toAbsoluteUrl} from '../../../../../../_metronic/_helpers';
import ButtonAction from '../../../../_common/components/ButtonAction';
import FieldInput from '../../../../_common/components/FieldInput';
import FieldSelect from '../../../../_common/components/FieldSelect';
import {DatePicker} from '../../../../_common/components/FieldDatepicker';
import {floatValue, formatStringToNumber} from '../../../../../../utils/format';
import {optionsCardType, optionsDealType} from '../../../constants/options';
import {
  createDocumentGridReceiptSelectStyles,
  createDocumentGridSelectStyles
} from '../../../../_common/selectStyles/customSelectStyles';
import styles from '../styles.module.scss';

const RowCreditCard = ({
                         setFieldValue,
                         fieldsSet,
                         values,
                         removeRow
                       }) => {
  const [startDate, setStartDate] = useState(new Date());

  return (
    <div className={styles.creditCardRowContainer}>
      <DatePicker
        value={startDate}
        onChange={(date) => {
          setStartDate(date);
          setFieldValue(fieldsSet.date, date);
        }}
        minDate={moment().subtract(1, 'months').format('YYYY-MM-DD')}
        maxDate={moment().add(1, 'years').format('YYYY-MM-DD')}
      />
      <FieldInput fieldId={fieldsSet.cardNum} onChange={formatStringToNumber}/>
      <FieldSelect
        fieldId={fieldsSet.cardType}
        customStyles={{...createDocumentGridSelectStyles, ...createDocumentGridReceiptSelectStyles}}
        options={optionsCardType}
        value={values[fieldsSet.cardType]}
      />
      <FieldSelect
        fieldId={fieldsSet.dealType}
        customStyles={{...createDocumentGridSelectStyles, ...createDocumentGridReceiptSelectStyles}}
        options={optionsDealType}
        value={values[fieldsSet.dealType]}
      />
      <FieldInput fieldId={fieldsSet.numPayments} onChange={formatStringToNumber}/>
      <FieldInput fieldId={fieldsSet.price} onChange={floatValue}/>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'error'}
        onClick={removeRow}
        label={<img src={toAbsoluteUrl('/media/common/Delete_red.svg')} alt="delete"/>}
        customClassnames={'mr-4 ml-auto'}
        avoidDoubleClick={false}
      />
    </div>
  );
};

export default RowCreditCard;